import { FjButton, fjButtonTypes } from 'components/primitives';
import type { FjButtonType } from 'components/primitives/fj-button';
import React from 'react';
import styled from 'styled-components';
import type { DefaultTheme } from 'styled-components';

interface WrappedButtonProps extends React.ComponentProps<typeof FjButton> {
  children?: React.ReactNode;
}

interface AttrsProps {
  theme: DefaultTheme;
  buttonType?: FjButtonType;
}

const Button = styled(({ children, ...props }: WrappedButtonProps) => (
  <FjButton {...props}>{children}</FjButton>
)).attrs(({ theme, buttonType }: AttrsProps) => ({
  disabledStyle: {
    color: theme.colors.buttonDisabled,
    background: theme.colors.buttonDisabledBg,
  },
  defaultStyle: {
    color: theme.colors.selectableLightBg,
    background: theme.colors.white,
  },
  buttonType: buttonType || fjButtonTypes.MD,
}))`
  border-radius: ${({ theme }) => theme.borderRadius};
  font-size: ${({ theme }) => theme.fontSizes.buttonSmall};
`;

export default Button;
